import { render, staticRenderFns } from "./afterSaleDetails.vue?vue&type=template&id=57aef1b4&scoped=true"
import script from "./afterSaleDetails.vue?vue&type=script&lang=js"
export * from "./afterSaleDetails.vue?vue&type=script&lang=js"
import style0 from "./afterSaleDetails.vue?vue&type=style&index=0&id=57aef1b4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aef1b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57aef1b4')) {
      api.createRecord('57aef1b4', component.options)
    } else {
      api.reload('57aef1b4', component.options)
    }
    module.hot.accept("./afterSaleDetails.vue?vue&type=template&id=57aef1b4&scoped=true", function () {
      api.rerender('57aef1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/afterSaleDetails.vue"
export default component.exports